import { SparklesIcon } from "@heroicons/react/24/outline";
import { usePreviewDesignToggle } from "hooks/use-preview-design-toggle";
import * as React from "react";

interface PreviewDesignToggleProps {
    label: string;
}

export const PreviewDesignToggle: React.FC<PreviewDesignToggleProps> = ({ label }) => {
    const { isUseNewDesignChecked, handlePreviewChange } = usePreviewDesignToggle();

    const handleClick = React.useCallback(
        (e: React.MouseEvent<HTMLAnchorElement>) => {
            e.preventDefault();
            handlePreviewChange(true);
        },
        [handlePreviewChange],
    );

    if (isUseNewDesignChecked) {
        return null;
    }

    return (
        <div className="flex items-center justify-center h-full">
            <a
                href="#"
                onClick={handleClick}
                className="text-xs text-brand-700 hover:text-brand-800 hover:underline whitespace-nowrap bg-brand-200 rounded-full px-2 py-0">
                <div className="flex items-center space-x-1 py-1 font-bold">
                    <SparklesIcon className="h-5 w-5" aria-hidden="true" />
                    <span>{label}</span>
                </div>
            </a>
        </div>
    );
};
